const TRANSLATION = {
  buyModal: {
    afterFree: 'A ingyenes próbaidőszak után',
    btn: 'Próbáld ki ingyen',
    freeTrial: '3 napos ingyenes próba',
    monthLabel: 'hónap',
    selectLabel: 'Válasszon egy tervet',
    title: 'Előfizetési csomag',
    yearLabel: 'év',
  },
  contact: {
    block1:
      'Egyéni igények, kérdések vagy javaslatok esetén lépjen kapcsolatba velünk a contact@noam.tools címen. Gyorsan válaszolunk.',
    block2:
      'Támogasd minket azáltal, hogy értékeled minket a Google Apps Extension boltban ★★★★★-al.',
    block3: 'Segíts másoknak az ezt a bővítményt megosztva:',
    title: 'Kapcsolat',
  },
  help: {
    AquickOverviewOfNoam: 'Noam rövid áttekintése',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Kedvencek kezelése',
    Fixedplugin: 'Javított Bővítmény',
    Focusing: 'Koncentráció',
    Free: 'Ingyenes',
    FreeTrialBenefits: 'Ingyenes Próbafolyamat Előnyei',
    GoWithWikipedia: 'Használja a Wikipédiát',
    GoWithYouTube: 'Használj YouTube-t',
    HoverTranslation: 'Hover Fordítás',
    Howtouse: 'Használati útmutató',
    ImageTranslation: 'Képtöltés',
    InstantTranslation: 'Gyors fordítás',
    Membership: 'Tagság',
    NoamHelp: 'Noam segít neked lefordítani és összefoglalni',
    PDFparallelTranslation: 'PDF párhuzamos fordítás',
    ParallelTranslation: 'Párhuzamos fordítás',
    SkipAllSteps: 'Összes lépés átugrása',
    Summary: 'Összegzés',
    Translation: 'Fordítás',
    TryItForFree: 'Próbáld ki ingyen',
    Video: 'Videó',
    VideoSummary: 'Videó összefoglalás',
    VideoTranslation: 'Videofordítás',
    WebSummary: 'Web Összegzés',
    WordSelectionTranslation: 'Szóválasztási Fordítás',
    benefits: 'Várnak rád előnyök!',
    dayFree: '3 napos ingyenes próba',
    done: 'Kész',
    next: 'Következő',
    pin: 'Rögzítse Noamot könnyebb hozzáférhetőség érdekében～～',
    planIsNotExist: 'A terv nem érhető el',
    startWiki: 'Kezdjük a Wikipédiával!',
    startYoutube: 'Kezdjük a YouTube-val!',
    try: 'Próbáld ki',
    tryNow: 'Próbáld ki most!',
  },
  home: {
    PDFTranslate: {
      desc: 'Kétnyelvű fordítás + Chat PDF',
      sub1: {
        desc: 'A kétnyelvű olvasás lehetővé teszi, hogy az eredeti szöveget és a fordítást oldalt oldalon hasonlítsd össze, javítva az olvasási hatékonyságot.',
        title: 'Kétnyelvű Olvasás',
      },
      sub2: {
        desc: 'Az AI elemzi és összefoglalja, és válaszolhat a kérdéseidre a PDF tartalma alapján.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-vezérelt PDF-fordítás nagyobb pontosság és hatékonyság érdekében.',
        title: 'Pontosság és Hatékonyság',
      },
      title: 'PDF Fordítás',
    },
    aiAssistant: {
      desc: 'A webes fordítás intelligensebbé és kényelmesebbé tétele',
      panel1: {
        desc: 'A kétnyelvű összefüggő fordítások segítik, hogy összehasonlítsd az eredeti szöveget a fordítással, így jobban megérted és növeled a olvasási hatékonyságot.',
        title: 'Kétnyelvű fordítás',
      },
      panel2: {
        left: {
          desc: 'Amikor böngész egy weboldalt, görgessen fölé a lefordítani kívánt tartalomra, hogy megtekintse a fordítást.',
          title: 'Felfüggesztett Fordítás',
        },
        right: {
          desc: 'Amikor böngész egy weboldalt, válassza ki a lefordítani kívánt szöveget a fordítás megtekintéséhez.',
          title: 'Szövegválasztás fordítása',
        },
      },
      panel3: {
        one: {
          desc: 'Fordítson le és foglalja össze weboldalakat és videótartalmakat bármikor, bárhol, hogy zökkenőmentesebb élményt nyújtson!',
          title: 'Kattintson és Klikkeljen',
        },
        three: {
          desc: 'Az AI-vezérelt nagy nyelvi modell biztosítja a fordítás pontosságát és konzisztenciáját, javítva ezzel az olvasási élményt.',
          title: 'AI-vezérelt',
        },
        two: {
          desc: 'Többnyelvű teljes lefedettség, kétnyelvű akadálymentes olvasás, egykattintásos fordítás – tapasztalja meg a különbséget!',
          title: 'Komplexebb és kényelmesebb',
        },
      },
      panel4: {
        tab1: {
          desc: 'Az efficiency szakértője - Noam a ChatGPT segítségével lefordítja és összefoglalja a YouTube videó tartalmakat, hogy időt takarítson meg neked!',
          key: 'Videó',
          title: 'Videofordítás és Összefoglalás',
        },
        tab2: {
          desc: 'Kattintson a képek fordításához a web böngészése közben.',
          key: 'Kép',
          title: 'Kép Fordítás',
        },
        tab3: {
          desc: 'Gyorsan kinyeri a kulcsfontosságú információkat a weboldalakról és összefoglalást nyújt, javítva az olvasási hatékonyságot.',
          key: 'Web',
          title: 'Web Fordítás és Összefoglalás',
        },
        tag1: 'Egyszerű',
        tag2: 'Hatékony',
        tag3: 'Könnyen érthető',
      },
      title: 'AI Asszisztens',
    },
    getStart: 'Kezdődj el',
    getStartedForFree: 'Kezdje el ingyen',
    howItWork: {
      desc: 'A Noam AI-modellöket integrál, hogy intelligens élményt nyújtson a felhasználóknak a többnyelvű weboldal fordításához és összegzéséhez, PDF- és képfordításához, valamint videofordításához és összegzéséhez.',
      title: 'Hogyan működik',
    },
    lastBlock: { desc: 'Jobb AI-fordítás zökkenőmentesebb olvasási élményért' },
    top: {
      desc: 'A Noam egy ingyenes AI böngészőbővítmény, amely segít fordítani és összefoglalni weboldalakat, videókat és PDF tartalmakat.\n      Csatlakozz a Noamhoz és tapasztald meg a mágikat!',
      title1: 'Egy Varázslat',
      title2: 'Egy Kattintás',
    },
    userReviews: {
      desc: 'Ötcsillagos vélemények a Chrome Web Store-on',
      title: 'Felhasználói vélemények',
    },
  },
  installTips: {
    btn: 'Próbáld Most',
    text: 'Telepítse a „Noam Browser Plugin”-t a további funkciók engedélyezéséhez! Webes keresztreferencia,\n    webes videóösszefoglalás és még sok más!',
  },
  locale: {
    af: 'afrikaans',
    am: 'amhara',
    ar: 'arab',
    as: 'asszami',
    auto: 'Automatikus felismerés',
    az: 'azerbajdzsáni',
    ba: 'bashkir',
    bg: 'bolgár',
    bn: 'bengáli',
    bo: 'tibeti',
    bs: 'bosnyák',
    ca: 'katalán',
    cs: 'cseh',
    cy: 'walesi',
    da: 'dán',
    de: 'német',
    dsb: 'alsó szorb',
    dv: 'divehi',
    el: 'görög',
    en: 'angol',
    es: 'spanyol',
    et: 'eesti',
    eu: 'baszk',
    fa: 'perzsa',
    fi: 'finn',
    fil: 'filippino',
    fj: 'fidzsi',
    fr: 'francia',
    frCA: 'francia (Kanada)',
    ga: 'ír',
    gl: 'galíciai',
    gom: 'konkani',
    gu: 'guzsarati',
    ha: 'hausa',
    he: 'héber',
    hi: 'hindi',
    hr: 'horvát',
    hsb: 'felső szorb',
    ht: 'haiti créole',
    hu: 'magyar',
    hy: 'örmény',
    id: 'indonéz',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'islendiai',
    it: 'olasz',
    iu: 'inuktitut',
    iuLatn: 'inuktitut (latin)',
    ja: 'japán',
    ka: 'grúz',
    kk: 'kazah',
    km: 'khmer',
    kmr: 'Észak-kürt',
    kn: 'kannada',
    ko: 'koreai',
    ku: 'kürd (közép)',
    ky: 'kirgiz',
    ln: 'lingála',
    lo: 'Lao',
    lt: 'litván',
    lug: 'Ganda',
    lv: 'latv',
    lzh: 'kínai (irodalmi)',
    mai: 'Maithili',
    mg: 'madagaszkár',
    mi: 'maori',
    mk: 'macedón',
    ml: 'malajálam',
    mnCyrl: 'mongol (cirillica)',
    mnMong: 'mongol (tradicionális)',
    mr: 'maráthi',
    ms: 'maláj',
    mt: 'málta',
    mww: 'Hmong Daw',
    my: 'Mianmar (burma)',
    nb: 'norvég',
    ne: 'nepáli',
    nl: 'holland',
    noSearchLang: 'Nyelv nem támogatott',
    nso: 'Észak-Sesotho',
    nya: 'nyanja',
    or: 'Odia',
    otq: 'Querétaro-otomi',
    pa: 'puncsabi',
    pl: 'lengyel',
    placeholder: 'Keresés',
    prs: 'Dári',
    ps: 'pasztó',
    pt: 'portugál (brasil)',
    ptPT: 'portugál (Portugália)',
    ro: 'román',
    ru: 'orosz',
    run: 'rundi',
    rw: 'kinjaruanda',
    sd: 'szindhi',
    si: 'szinhala',
    sk: 'szlovák',
    sl: 'szlovén',
    sm: 'szamói',
    sn: 'szona',
    so: 'szomáli',
    sq: 'albán',
    srCyrl: 'Szerb (cirill)',
    srLatn: 'Szerb (latin)',
    st: 'sesotho',
    sv: 'svéd',
    sw: 'szuahili',
    ta: 'tamil',
    te: 'telugu',
    th: 'thai',
    ti: 'tigrinya',
    tk: 'türkmen',
    tlhLatn: 'Klingon',
    tlhPiqd: 'Klingon (pIqaD)',
    tn: 'szetsvana',
    to: 'tongan',
    tr: 'török',
    tt: 'tatár',
    ty: 'tahitiai',
    ug: 'uighur',
    uk: 'ukrán',
    ur: 'urdú',
    uz: 'Ozsbi (latin)',
    vi: 'vietnámi',
    xh: 'xhosai',
    yo: 'joruba',
    yua: 'jukatecki maya',
    yue: 'kantonai (tradicionális)',
    zh: 'kínai',
    zhHans: 'Egyszerűsített kínai',
    zhHant: 'Kínai hagyományos',
    zu: 'zulu',
  },
  login: {
    and: 'és',
    btn: 'Bejelentkezés Google fiókkal',
    btn1: 'Jelentkezzen be most',
    desc: 'Jelentkezzen be a további élmények felfedezéséhez',
    policy: 'Adatvédelmi Nyilatkozat',
    terms: 'Használati feltételek',
    tips: 'A regisztrációval elfogadom a',
    title: 'Üdvözöljük Noam-ban',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Követ', twitter: 'Twitter' },
    legal: { policy: 'Adatvédelmi szabályzat', terms: 'Szolgáltatási feltételek', title: 'Jogi' },
    product: {
      image: 'Képtömb fordítás',
      pdf: 'PDF Fordítás',
      title: 'Termékek',
      video: 'Videofordítás és Összefoglalás',
      web: 'Web Fordítás és Összegzés',
    },
    resources: { title: 'Erőforrások' },
    tools: { title: 'Eszközök', pdf: 'PDF fordítás' },
  },
  pageHeader: {
    contact: 'Kapcsolat',
    help: 'Segítség',
    logout: 'Kijelentkezés',
    logoutSucc: 'Kijelentkezve.',
    pricing: 'Árazás',
    settings: 'Beállítások',
    signUp: 'Bejelentkezés',
  },
  pdf: {
    autoDetect: 'Automatikus Felismerés',
    cancelBtn: 'Mégse',
    cancelUpload: 'Mégsem',
    chatPdf: {
      summaryError: 'A összefoglalás sikertelen, próbálja meg később újra',
      chatError: 'A chat sikertelen, próbálja meg később újra',
      Search: 'Keresés',
      cancel: 'Mégsem',
      chatTitle: 'Üdvözöljük Noam-ban! Íme a PDF fájl összefoglalása:',
      clear: 'Tisztázatlan',
      clearContent:
        'Ez egy új beszélgetést fog indítani. Az aktuális beszélgetés nem lesz mentve. Biztos vagy benne?',
      clearDialogTitle: 'Kérjük, erősítse meg',
      clearSucc: 'Tisztítva',
      copy: 'Másolás',
      copySucc: 'Másolva',
      delete: 'Törlés',
      deleteCancel: 'Mégse',
      deleteContent: 'Ez a PDF fájl törlés után nem állítható vissza. Biztosan folytatja?',
      deleteOk: 'Törlés',
      deleteSuccess: 'Törölve',
      deleteTitle: 'Törlés megerősítése',
      expand: 'Összecsukódás',
      historyTitle: 'Történelem',
      listError:
        'Nem sikerült betölteni az olvasási listát. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
      loading: 'Betöltés...',
      noDataDesc: 'Még nincs előzmény.',
      noMore: 'Nincs több tartalom.',
      placeholder: 'Kérdezhet bármit erről a PDF-ről',
      summaryTitle: 'Ezek a kérdések érdekelhetnek: ',
    },
    collectionEmpty: 'A gyűjteményed üres.',
    collectionTab: 'Jegyzetek',
    dataLoading: 'Betöltés...',
    dialogContent: 'Biztosan törölni szeretnéd ezt?',
    dialogTitle: 'Kérjük, erősítse meg',
    download: {
      both: 'kétnyelvű',
      btn: 'Mentés',
      cancel: 'Ennek az ablaknak a bezárása megszakítja a PDF letöltést. Biztosan megszakítja?',
      desc: 'Mentés eszközre: A fordításokat képekként tölti le; Mentés és nyomtatás: A fordításokat eredeti formátumban tölti le, másolási támogatással.',
      download: 'Letöltés',
      downloadMsg1: 'PDF fordítási előrehaladás:',
      downloadMsg2: 'Becsült hátralévő idő:',
      downloadSucc: 'A PDF készen van! Kattintson a mentéshez.',
      downloadTip:
        'PDF letöltése. Ne zárja be ezt az ablakot a letöltési hibák elkerülése érdekében.',
      error: 'A mentés sikertelen. Próbálja meg nyomtatni helyette.',
      fileName: 'Fájlnév:',
      fileType: 'Fájltípus:',
      loading: 'Mentés...',
      loading2: 'Betöltés...',
      minute: 'Perc...',
      msg1: 'Ezen dokumentum egyes fordításai hosszabbak, mint az eredeti szöveg, és az letöltött fájlban átfedhetnek. Ajánljuk a weboldalon való olvasást.',
      msg2: 'A fordítás még nem kész. Kérjük, töltse le a fordítás befejezése után.',
      msg3: '2. Egyes fordítások túl hosszúak. Olvasson a weboldalon, hogy elkerülje a szöveg átfedését.',
      msg4: 'A fordítási feladatok folyamatban vannak. Kérjük, próbálja meg újra, miután befejeződtek.',
      progress:
        'PDF fordítása. Előrehaladás: {{progress}}, Becsült hátralévő idő: {{minutes}} perc...',
      save: 'Mentés eszközre',
      savePrint: 'Mentés és Nyomtatás',
      success: 'Letöltve',
      trans: 'Csak fordítás',
      transContinue: 'Folytassa a fordítást',
    },
    downloadBtn: 'Letöltés',
    dragTipModal: {
      black: 'tér',
      leftKey: 'bal gomb',
      ok: 'Értem',
      press: 'Nyomás',
      tips: 'húzni és megtekinteni',
    },
    entry: 'PDF-ek',
    fileErrMsg:
      'A fájl olvasása sikertelen. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    fileMsg: 'Jelenlegi fájlméret:',
    fileMsg2: 'Kérjük, töltsön fel egy 300 MB-nál kisebb fájlt.',
    freeBannerBtn: 'Frissítés',
    freeBannerTips: 'A ingyenes PDF fordítások korlátja elérve',
    guide: {
      placeholder: 'Illessze be itt a PDF hivatkozást',
      start: 'Fordítás indítása',
      text1: 'Kétnyelvű Olvasás',
      text2:
        'Olvass kéttesprachekben, hogy oldalt oldalra hasonlítsd össze az eredeti szöveget és a fordítást, és növeld a hatékonyságot.',
      text3: 'Beszélj a PDF-del',
      text4:
        'Képességekkel ausgestatt AI-analízis és összegzés. Tedd fel kérdéseket a PDF-documentumról, és kapj azonnali válaszokat.',
      text5: 'Pontos és Hatékony',
      text6: 'AI-alapú PDF-fordítás nagyobb pontosság és hatékonyság érdekében.',
      title1: 'Kétnyelvű fordítás',
      title2: 'Beszéljen PDF-jével',
      toast: 'Kérjük, adjon meg egy érvényes online PDF linket, amely .pdf végződik',
    },
    hasTransTask: 'A fordítás folyamatban van. Kérjük, várjon.',
    hoverTrans: 'Eltérített szövegek fordítása',
    initial: 'PDF fordítása',
    installText: 'Az mindennapi fordítások egyértelmű megoldása.',
    installText2: 'Kérjük, először telepítse az bővítményt',
    installTips:
      'Telepítse az bővítményt még több PDF-fordítás és gördülékenyebb weboldal-fordítás érdekében:',
    kw: 'fűrész',
    link: 'link',
    listError:
      'A PDF-ek betöltése sikertelen. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    memoTotalCount: 'összesen 1 elem',
    new: 'új fájl',
    noId: 'Fájl azonosító nem található.',
    notPdf: 'Csak PDF fájlok.',
    okBtn: 'Törlés',
    okBtn2: 'Értem',
    original:
      'Ön egy nagyon pontos és megbízható AI, amelyet úgy tervezték, hogy pontososan egy meghatározott JSON séma szerint generáljon JSON kimenetet.\n\nKötelező követni ezeket a szabályokat:\n1. Szigorúan kövesse a JSON séma struktúrát.\n2. Pontosan egyeztessen az összes adattípus, kötelező mező és korlátozással.\n3. NE adjon hozzá extra szöveget, magyarázatot, markdownot vagy megjegyzéseket.\n4. CSAK a JSON objektumot írja ki – ne kódblokkokat, ne előszót, ne csomagolást.\n\nA séma információi alább találhatók.\n- Séma neve: translate_result\n- JSON séma:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'Párhuzamos',
    parseErrDialogContent:
      'Ez a PDF-link nem fordítható közvetlenül. Kérjük, töltse le a PDF-t és töltsön fel fordítás céljából.',
    parseErrTips: 'A fájl elemzése sikertelen',
    parseFileToast:
      'A fájl elemzése sikertelen. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    pdfLoading: 'Elemzés...',
    searchPlaceholder: 'Keresés',
    selectTrans: 'Válasszon szöveget a fordításához',
    shareBtn: 'Megosztás',
    shareBtnText1: 'Megosztási link létrehozása',
    shareBtnText2: 'Megosztott tartalom frissítése',
    shareModal: {
      cancel: 'Mégsem',
      copy: 'Másolás',
      copySucc: 'Hivatkozás másolva',
      custom: 'Testreszabás:',
      errMsg:
        'A kiválasztott tartalom még nem lett teljesen lefordítva. Kérjük, fordítsa le megosztás előtt.',
      gen: 'Megosztás',
      modify: 'Szerkesztés',
      notSupport: 'Ez a nyelv jelenleg nem támogatott.',
      page: 'Oldalak',
      pageNuErr: 'Kérjük, adjon meg érvényes oldalszámot.',
      range: 'Hatálykör:',
      remain: 'maradék',
      remain1: 'Becsült teljes idő: ',
      search: 'Keresés',
      settings: 'Megosztási beállítások:',
      shareSetting: 'Megosztási beállítások',
      shareText: 'Megosztás',
      shareTips: 'Oszd meg a lefordított PDF linket barátaiddal:',
      sourceLang: 'Feladó:',
      target: 'Címzett:',
      text1: 'Megosztási beállítások',
      text2: 'Megosztási link létrehozása',
      totalPage: 'összesen 1 oldal',
      trans: 'Fordítás',
      translateTips:
        'Tipp: Ha a fordítás hosszabb ideig tart, bezárhatja ezt az ablakot, és később ossza meg.',
      translating: 'PDF fordítása...',
      update: 'Megosztási link frissítése',
    },
    shareMsg1: 'Megosztási link létrehozva.',
    shareMsg2: 'A megosztott tartalom frissítve.',
    shareMsg3:
      'Nem sikerült létrehozni a megosztási linket. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    shareMsg4:
      'A megosztott tartalom frissítése sikertelen. Próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    shareTips: 'A PDF-fordításod készen van! Osszd meg barátaiddal.',
    start: 'Kezdje el ingyenes próbaidőt',
    thumbnail: 'Tartalomjegyzék',
    toast1: 'PDF betöltése. Kérjük, próbálja meg később újra.',
    toast2: 'A PDF tartalom feldolgozás alatt van. A párbeszéd jelenleg nem támogatott.',
    toast3: 'Letöltés folyamatban. Kérjük, próbálja újra, miután a letöltés befejeződött.',
    toolbar: { Adjust: 'Sajátíts meg', autoFit: 'Automatikus illesztés' },
    trans: 'Fordítás',
    transSucc: 'A fordítás sikeres!',
    unLoginToast: 'Kérjük, jelentkezzen be a funkció használatához.',
    uploadBtn: 'Feltöltés',
    uploadErr:
      'A fájlfeltöltés sikertelen. Próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    uploadErrSignUrl:
      'Nem sikerült lekérni a feltöltési URL-t. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    uploadMsg1: 'Húzza ide és engedje el a fájlt.',
    uploadMsg2: 'Támogatott fájltípusok: PDF  |  Maximális fájlméret: 300MB',
    uploadMsg3: 'Kattintson a kiválasztáshoz vagy húzza ide és engedje el a fájlokat.',
    uploading: 'Feltöltés',
    uploadingMsg: 'Feltöltés folyamatban. Kérjük, várjon.',
    uploadingMsg1: 'A fájl feltöltődik. Kérjük, próbálja meg később ismét.',
    uploadingMsg2: 'A fájl jelenleg átalakítás alatt van. Kérjük, próbálja meg később ismét.',
    uploadingMsg3:
      'A konverziós folyamat kérése sikertelen. Próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    uploadingMsg4:
      'Noam nem férhet hozzá a helyi fájlokhoz. Kérjük, töltsön fel kézzel egy PDF-t a fordítás céljából.',
    uploadingMsg5:
      'A fájl URL-je nem sikerült lekérni. Kérjük, próbálja meg később újra, vagy lépjen kapcsolatba a támogatással.',
    video: 'videó',
    vipBannerBtn: 'Frissítés',
    vipBannerTips: 'Elérte a havi PDF fordítási limitjét.',
    webTrans: 'Teljes keresztreferencia',
  },
  pricing: {
    FAQ: 'GYIK',
    FQAObj: {
      a1: 'Igen, Noam egy ingyenes csomagot kínál, amelyet azonnal használhatsz.',
      a2: 'Három tagsági csomagot kínálunk: Pro, Pro+ és Enterprise. Választhat monthly vagy éves fizetést. Az éves számlázás jelentős megtakarításokat biztosít.',
      a3: 'Minden funkció elérhető mindkét csomagban. A fő különbség az ár: az éves előfizetések összességében olcsóbbak. A havi előfizetések minden hónapban kerülnek számlázásra, míg az éves csomagok évente egyszer. ',
      a4: 'A előfizetést bármikor lemondhatja a Fiókbeállítások menüpontban.',
      q1: 'Van ingyenes csomag?',
      q2: 'Milyen árképzési csomagok és fizetési lehetőségek állnak rendelkezésre?',
      q3: 'Mi a különbség a havi és az éves előfizetés között?',
      q4: 'Hogyan mondhatom le az előfizetést?',
    },
    around: 'Körül',
    billedMonthly: 'Havi számlázás',
    billedYearly: 'Éves számlázás',
    day: 'nap',
    desc: 'Összehasonlítsa az ajánlatokat és válassza ki a legjobbat',
    detailedCompare: 'Tervek összehasonlítása',
    discount: '20% kedvezmény',
    enterprise: {
      benefit1: 'Kiemelt Ügyfélszolgálat',
      benefit2: 'Több felhasználó',
      benefit3: 'Testreszabott Megoldások',
      benefit5: 'Foglalt Fiókigazgató',
      btn: 'Kapcsolat',
      recommendText: 'Egyéni Tervek (≥3 fő)',
      talkToUs: 'Kapcsolatba lépjen',
    },
    free: {
      benefit1: 'Gyorsfordítás 100 alkalom/nap',
      benefit2: 'Weboldal Fordítás és Összegzés',
      benefit3: '30 képfordítás',
      benefit4: 'Videofordítás és Összefoglalás',
      benefit5: '10 PDF fordítás',
      benefit6: '5 000 token',
      btn: 'Próbáld ki ingyen',
      recommendText: 'Ingyenes próba',
    },
    imageTranslation: 'Képfordítás',
    month: 'hónap',
    monthly: 'Havi',
    pageTitle: 'Árazás',
    pdf: {
      chat: 'PDF Chat Kérések',
      maxPage: 'Max. oldalak PDF-enként',
      translation: 'PDF Fordítás',
    },
    preMonth: 'Havi',
    pro: {
      benefit1: 'Kiemelt Ügyfélszolgálat',
      benefit2: '1 000 000 token/hónap',
      benefit3: 'Weboldal Fordítása és Összegzés',
      benefit4: '200 Képfordítás',
      benefit5: 'Videofordítás és Összegzés',
      benefit6: '200 PDF fordítás',
      btn: 'Kezdés',
      recommendText: 'Legnépszerűbb',
    },
    proPlus: {
      benefit1: 'Kiemelt Ügyfélszolgálat',
      benefit2: '3 000 000 token/hónap',
      benefit3: 'Webhelyfordítás és Összegzés',
      benefit4: '500 Képfordítás',
      benefit5: 'Videofordítás és Összegzés',
      benefit6: '500 PDF fordítás',
      recommendText: 'Legjobb Érték',
    },
    video: { summary: 'Videó összefoglalás', translation: 'Videofordítás' },
    web: {
      contrastiveTranslation: 'Kétnyelvű fordítás',
      dictionaryTranslation: 'Kiválasztás Fordítás',
      hoverTranslation: 'Felfelegő Fordítás',
      instantTranslation: 'Gyors fordítás',
      summary: 'Weboldal Összefoglaló',
    },
    yearly: 'Éves',
  },
  privacy: {
    block1:
      'A Noam ("Noam", "mi", "miénk" vagy "ünket") tiszi az Ön adatvédelmét, és elkötelezett az Önnel kapcsolatban vagy az Önről szerzett bármilyen információ védelmében. Ez az Adatvédelmi Nyilatkozat ismerteti a személyes adatok gyűjtésére és felhasználására vonatkozó gyakorlatainkat az Ön által az oldalunkon, alkalmazásainkon és szolgáltatásainkon (együttes nevén a „Szolgáltatások”) végzett tevékenység során. Ez az Adatvédelmi Nyilatkozat nem érvényesül az üzleti termékek ügyfeleink nevében kezelt tartalmakra, például az API-junkra. Ezeknek az adatoknak a felhasználása az ügyfélszerződésünkre van kötve, amely lefedi ezeknek a termékeknek az elérését és felhasználását.',
    block10:
      'Kereskedelmi szempontból ésszerű technikai, adminisztratív és szervezeti intézkedéseket alkalmazunk annak érdekében, hogy az online és offline személyes adatokat védjük elvesztés, visszaélés, jogosulatlan hozzáférés, közzététel, módosítás vagy ellenséges cselekedetek ellen. Azonban egyetlen internetes vagy e-mail küldetés sem garantálhat teljes biztonságot vagy pontosságot. Különösen az Ön által nekünk vagy nálunkról küldött e-mailek nem biztosan biztonságosak. Ezért különösen óvatosan kell eljárnia, amikor eldönti, milyen információkat küld nekünk a szolgáltatás vagy e-mailen keresztül. Ezenkívül nem vállalunk felelősséget a szolgáltatás vagy harmadik felek webhelyein található adatvédelmi beállítások vagy biztonsági intézkedések akadályozásáért. A személyes adatokat addig őrizzük meg, amíg szükséges az Önnek szolgáltatás nyújtásához vagy más jogos üzleti célok, például viták megoldásához, biztonsági és segurança okokhoz vagy jogi kötelezettségeink betartásához. Az adatmegőrzés időtartama számos tényezőtől függ, mint például az információ mennyisége, jellege, érzékenysége, a jogosulatlan felhasználás vagy közzététel lehetséges kockázatai, az információ feldolgozásának céljai és egyéb jogilag kötelező szempontok.',
    block11:
      'Időről időre frissíthetjük ezt a Adatvédelmi Szabályzatot. Ha ezt tesszük, a frissített verziót erre az oldalon fogjuk közzétenni, hacsak az alkalmazandó jogszabályok nem írnak elő mást.',
    block12:
      'Ha bármilyen kérdése van vagy aggálya merül fel erről a Adatvédelmi szabályzatról, lépjen kapcsolatba ügyfélszolgálatunkkal. E-mail:',
    block2: 'A következő személyes adatokat ("Személyes Adatok") gyűjtjük Önnel kapcsolatban:',
    block3:
      ' Ön által szolgáltatott információk: Ha fiókot hoz létre a szolgáltatásaink használatához vagy kommunikál velünk, a következő személyes adatokat gyűjtjük:',
    block4:
      'Személyes adatokat, amelyeket automatikusan kapunk a szolgáltatások használatából: Amikor hozzáférsz, használod vagy lépsz kapcsolatba a szolgáltatásokkal, a következő információkat kapunk a hozzáférésedről, használatodról vagy interakciódról („Technikai információk”):',
    block5: 'Személyes adatokat a következő célokra használhatjuk:',
    block6:
      'Összefoglaló vagy azonosítás nélküli információk: Összefoglalhatjuk vagy azonosítás nélküli formában készíthetjük a személyes adatokat annak azonosítás céljából történő újbóli felhasználásának megakadásához, és ilyen információkat használhatunk szolgáltatásaink hatékonyságának elemzésére, szolgáltatásaink fejlesztésére és funkcióinak bővítésére, kutatás végzésére以及类似的目的。此外，我们可能会分析服务用户的一般行为和特征，并与第三方共享汇总信息，发布此类汇总信息或使其普遍可用。我们可以通过服务、Cookie以及本隐私政策中描述的其他方式收集汇总信息。我们将以匿名或去标识化形式维护和使用去标识化信息，除非法律要求，否则我们不会尝试对这些信息进行重新标识。',
    block7:
      'Bizonyos esetekben személyes adatainkat harmadik feleknek továbbíthatjuk anélkül, hogy erről további értesítést küldenénk Önnek, kivéve ha a jog előírja: ',
    block8:
      'Függően a földrajzi elhelyezkedésétől, az Európai Gazdasági Térségben, az Egyesült Királyságban és világszerte élő személyek bizonyos jogszabályi jogokkal rendelkezhetnek személyes adataik tekintetében. Például joguk lehet:',
    block9:
      'A szolgáltatás tartalmazhat hivatkozásokat más, Noam által nem üzemeltetett vagy ellenőrzött webhelyekre, beleértve a közösségi média szolgáltatásokat („Harmadik fél webhelyek”). Azokat az információkat, amelyeket megosztasz Harmadik fél webhelyeivel, a Harmadik fél webhelyek saját adatvédelmi szabályzatai és szolgáltatási feltételei szabályozzák, nem pedig ez az Adatvédelmi Szabályzat. Ezeket a hivatkozásokat kényelem miatt biztosítjuk, és nem jelentik azt, hogy támogatjuk vagy áttekintettük ezeket a webhelyeket. Kérjük, lépjen kapcsolatba közvetlenül a Harmadik fél webhelyeivel azok adatvédelmi szabályzatairól és feltételeiről szóló információkért.',
    subBlock1:
      'Fiókinformációk: Amikor fiókot hoz létre platformunkon, gyűjtjük a fiókjához kapcsolódó információkat, beleértve a nevedet, a kapcsolati adatokat, a fiók hitelesítő adatait, a fizetési kártya információkat és a tranzakciótörténetet („Fiókinformációk”).',
    subBlock10: 'Szolgáltatások biztosítása, kezelése, karbantartása és/vagy elemzése;',
    subBlock11: 'Kommunikálás veled',
    subBlock12: 'Új termékek és szolgáltatások fejlesztése;',
    subBlock13:
      'A csalás, bűnözés vagy szolgáltatásaink missztönies felhasználásának megelőzése, valamint az IT-rendszereink, architektúráink és hálózataink biztonságának védelme;',
    subBlock14: 'Vállalkozási átadások lebonyolítása;',
    subBlock15:
      'Jogi kötelezettségeknek és jogi eljárásoknak való megfelelés, jogaink, adatvédelmünk, biztonságunk vagy tulajdonunk védelme, valamint a kapcsolt vállalataink, Önnek vagy más harmadik feleknek az ilyen jogainak, adatvédelmének, biztonságának vagy tulajdonának védelme.',
    subBlock16:
      'Szállítók és szolgáltatók: Az üzleti működési szükségletek kielégítése és bizonyos szolgáltatások és funkciók végrehajtása érdekében személyes adatokat továbbíthatunk szállítóknak és szolgáltatóknak, beleértve a hosting szolgáltatókat, felhőszolgáltatókat, egyéb informatikai szolgáltatókat, e-mail kommunikációs szoftvereket és webanalitikai szolgáltatókat stb. Ezek a partnerek csak a mi irányításunk alapján férhetnek hozzá személyes adatokhoz, feldolgozhatják vagy tárolhatják ezeket az általunk kért feladatok elvégzése során.',
    subBlock17:
      'Vállalkozási átvitelek: Ha stratégiai tranzakciókban veszünk részt, szervezeti átalakításokat végzünk, bankrotsszavazatot kapunk, bankrot vállalkozást veszünk át, vagy szolgáltatásainkat átadjuk egy másik szolgáltatóhoz (együttes neve: „Tranzakciók”), akkor személyes adatait és egyéb információit megoszthatjuk a tranzakció partnerjeivel és más, a Tranzakciókban résztvevő felekkel a megfelelő ellenőrzés során, és a Tranzakciók részeként más eszközökkel együtt továbbítjuk egy utód- vagy kapcsolt vállalkozásnak.',
    subBlock18:
      'Jogi követelmények: Személyes adatait megoszthatjuk kormányzati szervel, ipari partnerekkel vagy egyéb harmadik felekkel, beleértve az Önnel kapcsolatos interakcióadatainkat szolgáltatásainkkal kapcsolatban: (1) ha jogszabály előírja, vagy ha úgy gondoljuk, hogy az ilyen cselekvés szükséges a jogi kötelezettségek betartására; (2) jogaink vagy tulajdonunk védelme és érvényesítése érdekében; (3) ha egyoldalúan meghatározzuk, hogy a felhasználási feltételeink, szabályzataink vagy a jogszabályok megsértése történt; (4) csalás vagy egyéb illegális tevékenységek észlelése vagy megelőzése érdekében; (5) termékeink, alkalmazottaink vagy felhasználóink, valamint a közbiztonság, biztonság és integritás védelme érdekében; vagy (6) jogi felelősség elleni védekezés érdekében.',
    subBlock19:
      'Hozzáférhet személyes adataihoz és az adatok feldolgozásáról szóló információkhoz.',
    subBlock2:
      'Amikor szolgáltatásainkat használja, személyes adatokat gyűjtünk a bemeneteiből, fájlfeltöltéseiből vagy az Ön által szolgáltatónak küldött visszajelzéseiből („Tartalom”).',
    subBlock20: 'Kérjük, törölje személyes adatait our rekordjaiból.',
    subBlock21: 'Ellenőrizd vagy frissítsd a személyes adataidat.',
    subBlock22: 'Személyes adataid átvitele harmadik félnek (adathordozhatóság).',
    subBlock23: 'Korlátozza, hogyan dolgozzuk fel a személyes adatait.',
    subBlock24:
      'Vonja vissza az engedélyét – amikor az adatfeldolgozás jogalapja az Ön beleegyezése, bármikor visszavonhatja ezt az engedélyt.',
    subBlock25: 'Protestálhatja személyes adatai feldolgozásának módját.',
    subBlock26: 'Szolgáltatásaink fejlesztése és kutatás végzés;',
    subBlock3:
      'Kommunikációs információk: Ha üzeneteket küldesz nekünk, gyűjtjük a nevedet, a kapcsolati adataidat és az üzeneteid tartalmát („Kommunikációs információk”).',
    subBlock4:
      'Társas média információk: Társas média platformokon, mint például az Instagram, Facebook, Medium, Twitter, YouTube és LinkedIn, oldalaink vannak. Amikor interakcióba lép a társas média oldalainkkal, gyűjtjük az Ön által自愿提供的 személyes adatokat, például a kapcsolatadatait („Társas média információk”). Ezenkívül a társas média oldalainkat üzemeltető cégek összegyűjtött információkat és elemzéseket is szolgáltathatnak arról, hogyan működnek társas média tevékenységeink.',
    subBlock5:
      'Naplózási adatok: Az Ön böngészője által automatikusan küldött információk szolgáltatásaink használata során. A naplózási adatok közé tartozik az Internet Protocol (IP) cím, a böngészőtípus és beállításai, a kérések dátuma és időpontja, valamint az Ön weboldalunkkal való interakciója.',
    subBlock6:
      'Használati adatok: Automatikusan gyűjthetjük az Ön szolgáltatás-használatával kapcsolatos információkat, mint például a megtekintett vagy vele interaktált tartalomtípusok, a használt funkciók, a végrehajtott műveletek, valamint az időzóna, az ország, az elérési dátum és idő, a felhasználói ügynök és verzió, az asztali vagy mobil eszköz típusa és az internetkapcsolat adatai.',
    subBlock7:
      'Eszközinformációk: Ez magában foglalja az eszköz nevét, operációs rendszert, eszközazonosítót és a használt böngészőt. A gyűjtött információk függhetnek az Ön által használt eszköz típusától és beállításaitól.',
    subBlock8:
      'Sütik: Sütiket használunk szolgáltatásaink működéséhez, kezeléséhez és az Ön élményének javításához. A „süti” olyan információ, amelyet a meglátogatott weboldal elküld a böngészőnek. A böngészőt beállíthatja úgy, hogy elfogadja az összes süti, elutasítsa az összes süti, vagy értesítse Önt, amikor süti kerül rendelkezésre, így dönthet az egyes esetekben, hogy elfogadja-e. Azonban a sütik elutasítása megakadályozhatja, hogy használja a weboldal egyes területeit vagy funkcióit, vagy negatívan befolyásolhatja megjelenítésüket vagy működésüket. További információkat a sütikről a All About Cookies oldalon talál. ',
    subBlock9:
      'Analitika: Különböző online analitikai termékeket használhatunk, amelyek sütiket (cookies) alkalmaznak annak érdekében, hogy segítse nekünk elemezni, hogyan használják a felhasználók szolgáltatásainkat, és javítsuk a felhasználói élményt a szolgáltatások használata során.',
    subTitle1: 'A gyűjtött személyes adatok',
    subTitle2: 'Hogyan használjuk a személyes adatokat',
    subTitle3: 'Személyes adatok közzététele',
    subTitle4: 'Az Ön jogai',
    subTitle5: 'Hivatkozások más webhelyekre',
    subTitle6: 'Információbiztonság és -megőrzés',
    subTitle7: 'Adatvédelmi szabályzat módosítása',
    subTitle8: 'Hogyan léphet kapcsolatba velünk',
    title: 'Adatvédelmi Nyilatkozat',
    updateTime: 'Frissítve: 2024. március 15.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Mindet elfogad',
    text: 'Az élményed javítása érdekében sütiket használunk tartalom és szolgáltatások személyre szabására.',
    title: 'Ez a weboldal sütiket használ',
  },
  slogen: 'A legegyszerűbb AI-asszisztens',
  stripe: {
    contact:
      'Kérjük, vedd fel velünk a kapcsolatot a contact@noam.tools címen bármilyen kérdés esetén!',
    fail: {
      btn: 'Újrapróbálkozás',
      text1: 'Nem tudtuk feldolgozni a fizetését.',
      text2: 'Ellenőrizd a kapcsolatot és próbáld újra.',
      title: 'Fizetés sikertelen',
    },
    succ: {
      btn: 'Gyerünk',
      text1: 'Üdvözöljük Noamban',
      text2: 'Kezdjük el!',
      title: 'Gratulálok',
    },
  },
  terms: {
    block1: 'Köszönjük, hogy használja a Noamot!',
    block10:
      '(a) Díjak és számlázás. Minden díjat ("Díjak") a vonatkozó árlapban foglalt árak és feltételek szerint, vagy a közösen írásban megállapodott feltételek szerint kell fizetnie. Fenntartjuk a jogot, hogy az árhibaakat vagy hibákat kijavítsuk, még akkor is, ha számlákat keltettünk ki vagy fizetést kaptunk. Teljes és pontos számlázási adatokat kell szolgáltatnia, beleértve egy érvényes és jogosított fizetési módot. A megállapodott periódikus időközönként fogjuk terhelni a fizetési módját, de ésszerűen megváltoztathatjuk a számlázási dátumot. Engedélyezi, hogy Noam, fióktevői és harmadik felek fizetési feldolgozói terheljék a fizetési módját. Ha a fizetése sikertelen, írásbeli értesítést küldünk neki, és felfüggesztheti a Szolgáltatás elérését, amíg a fizetés nem érkezik be. Ez az egyezményben másként nem előírt esetek kivételével a fizetések nem visszafizethetők.',
    block11:
      '(b) Adók. Külön kifejezéssel nem jelezve a díjak nem tartalmazzák az Egyesült Államok, állami, helyi vagy külföldi adókat, vámokat és hasonló adományokat („Adók”). Ön felelős az összes vásárláshoz kapcsolódó Adóért, kivéve azokat az Adókat, amelyek a nettó bevételünkre alapulnak, és amelyeket számlázunk Önnek. Ön beleegyezik, hogy késedelem nélkül fizeti meg ezeket az Adókat, és biztosítja nekünk jogilag érvényes adatvédelmi nyilatkozatokat, valamint megkapja az adatkezeléshez szükséges beleegyezéseket, és garanciát vállal arról, hogy az adatokat a vonatkozó jogszabályoknak megfelelően kezeli.',
    block12:
      '(c) Árfelszámítások. Árainkat megváltoztathatjuk azáltal, hogy értesítjük Önt a fiókján keresztül és/vagy weboldalunkon. Az ár emelések azonnal életbe lépnek a közzététel után. Bármely árváltozás az Ön fiókjának díjaira vonatkozik a változás hatálybalépési dátuma után.',
    block13:
      '(d) Disputák és késedelmes fizetések. Ha bármely díjat vagy adót kíván vitatni, kérjük, lépjen kapcsolatba a contact@noam.tools címmel a számla dátumából számított harminc (30) napon belül.',
    block14:
      '(e) Ingatlan Használat. Nem hozhat létre több fiókot ingyenes kreditek szerezésére. Ha megállapítjuk, hogy Ön nem jó hisztussal használja az ingyenes krediteket, kiszolgáltatási díjakat számíthatunk fel Önnek, vagy felfüggeszthetik a Szolgáltatás elérését.',
    block15:
      '(a) Titoktartás. Elérheted a Noam titkos információit. A titkos információkat csak azokhoz a célokra használhatod, amelyek engedélyezettek ezekkel a feltételekkel, és csak a Szolgáltatás használata céljából. Nem hozhatod nyilvánosságra a titkos információkat harmadik személyeknek, és a titkos információkat olyan módon kell megvédened, amely legalább annyira védő, mint saját hasonló titkos információid védelme, legalább ésszerű gondossággal. Titkos információ a Noam által titoknak megjelölt vagy az körülmények alapján ésszerűen titoknak kell kezelendő nem nyilvános információ, beleértve a szoftvert, a specifikációkat és egyéb nem nyilvános üzleti információkat. A titkos információ nem foglalja magában az alábbi információkat: (1) az Ön hibája nélkül nyilvánosságra jutott általánosan elérhető információkat; (2) azokat az információkat, amelyekre Önnek nem volt titoktartási kötelezettsége a jelen feltételek szerint történő fogadása előtt; (3) olyan információkat, amelyeket harmadik személy jogszerűen hozott nyilvánosságra Önnek titoktartási kötelezettség nélkül; vagy (4) olyan információkat, amelyeket Ön függetlenül fejlesztett ki a titkos információk felhasználása nélkül. Jogszabály, bíróság vagy egyéb kormányzati határozat előírásából eredően megoszthatod a titkos információkat, de előzetes írásos értesítést kell küldened a Noamnak ésszerű módon, és lehetőség szerint ésszerű erőfeszítéseket kell tenned a nyilvánosságra hozatal körének korlátozására, beleértve azokat a segítségeket, amelyekkel ellenőrizhetjük a nyilvánosságra hozatal kéréseket.',
    block16:
      '(b) Biztonság. Vegye fel alkalmazni az Ön hozzáférését és a Szolgáltatás használatát védelmére irányuló ésszerű és megfelelő intézkedéseket. Ha bármilyen sebezhetőséget vagy szabálytalanságot fedez fel a Szolgáltatás használatával kapcsolatban, azonnal lépjen kapcsolatba Noammal és adja meg a sebezhetőség vagy szabálytalanság részleteit.',
    block17:
      '((c) Személyes adatok feldolgozása. Ha Ön a Szolgáltatást használja személyes adatok feldolgozására, akkor köteles jogilag elégséges adatvédelmi nyilatkozatokat nyújtani és a ilyen adatok feldolgozásához szükséges beleegyezéseket szerezni, és garanciaztatta számunkra, hogy az ilyen adatokat alkalmazható jogszabályoknak megfelelően kezeli.)',
    block18:
      'Leállítás; felfüggesztés. Ezek az feltételek az Ön első szolgálat-használatakor lépnek életbe, és addig maradnak érvényben, amíg le nem lesznek állítva. Bármely okból bármikor megállíthatja ezeket a feltételeket azáltal, hogy abbahagyja a Szolgáltatás és a Tartalom használatát. Bármely okból előzetes értesítéssel megállíthatjuk ezeket a feltételeket. Közvetlenül megállíthatjuk ezeket a feltételeket, ha súlyosan megszegi a 2. fejezetet (Használati követelmények), a 5. fejezetet (Titkosítás, biztonság és adatvédelem), a 8. fejezetet (Vitakezelés) vagy a 9. fejezetet (Általános feltételek), vagy ha kapcsolatunkat bármely, kontrollünktől független harmadik fél technológiai szolgáltatóval megváltoztatjuk, vagy jogi vagy kormányzati kérelmeknek való megfelelés érdekében. felfüggesztheti a Szolgáltatáshoz való hozzáférését, ha nem kötelezi ezeket a feltételeket, vagy ha használata biztonsági kockázatot jelent nekünk vagy bármely harmadik félnek, vagy ha gyanúsítjuk, hogy használata csalásos, vagy kárhozatra tesz bennünket vagy bármely harmadik felet. kár.',
    block19:
      '(b) A megszüntetés hatásai. A megszüntetés után abba kell hagyni a Szolgáltatás használatát, és azonnal vissza kell adni vagy el kell tüntetni minden titkos információt, ahogyan azt mi irányítjuk. Ezeknek az előírásoknak azok az elemei, amelyek természetükből adódóan fennmaradnak a megszüntetés vagy lejárata után, beleértve, de nem korlátozva a 3. és 5-9. szekciókat, fennmaradnak.',
    block2:
      'Ezek a Használati Feltételek érvényesek Noam szolgáltatásainak használatára, beleértve az alkalmazásfejlesztési interfészeinket, szoftverünket, eszközöket, fejlesztői szolgáltatásokat, adatokat, dokumentációkat és weboldalt (együttes nevén "Szolgáltatások"). A szolgáltatásaink használatával Ön elfogadja ezeket a feltételeket. Adatvédelmi szabályzatunk magyarázza, hogyan gyűjtjük és használjuk a személyes adatokat.',
    block20:
      'Felelősségvállalás. Védelmet nyújt, felelősséget vállal és ártalmatlanul tart bennünket, kapcsolt vállalatainkat és személyzetünket minden olyan követelés, veszteség és kiadás (beleértve az ügyvédi díjakat) ellen, amelyek a Szolgáltatás használatából vagy与之相关派生， beleértve a tartalmadat, a Szolgáltatással相关的产品或服务 használatát, valamint ezen feltételek vagy alkalmazható jogszabályok megsértését.',
    block21:
      '(b) Kizárások. A Szolgáltatás "mint van" kerül biztosításra. A jogszabály许可的范围内 nem vállalunk semmilyen jellegű nyilatkozattal vagy garanciával kapcsolatban a Szolgáltatással, beleértve, de nem kizárólagosan a forgalmi érvényesség, adott célra való alkalamazhatóság, elégséges minőség, jogsértésmentesség és nyugodtenjoyment garanciákat, valamint bármilyen garanciát, amely az üzleti kapcsolatok vagy a kereskedelmi szokások során keletkezik. Nem garantáljuk, hogy a Szolgáltatás folyamatos, pontos vagy hibamentes legyen, vagy hogy a tartalmak biztonságosak, nem vesznek el vagy nem módosulnak.',
    block22:
      '(c) Felelősségkorlátozás. Sem mi, sem a kapcsolt vállalataink, sem a licencadók nem vállalnak felelősséget bármilyen közvetett, véletlen, speciális, következményes vagy büntető jellegű károkért, beleértve a profitveszteséget, a reputációromlást, az használati jogosultság elvesztését, az adatelvesztést vagy más immateriális veszteségeket, még akkor is, ha tájékoztattunk az ilyen károk lehetségéről. Ezeknek a feltételeknek megfelelően a teljes felelősségünk nem haladhatja meg az igényben előzményező tizenkét (12) hónapban a Szolgáltatáshoz fizetett díjakat vagy 100 amerikai dollárt (USD 100), melyik közül az nagyobb. Ez a fejezetben foglalt korlátozások a legnagyobb mértékben érvényesek az alkalmazható joggal megengedett mértékben.',
    block23:
      'Az Általános Szerződési Feltételek és Önnek a Szolgáltatásokhoz való hozzáférése az Egyesült Államok jogaira van alapon, kivéve az Egyesült Államok jogütközési szabályait. Az Alkalmazás használata további helyi, állami, nemzeti vagy nemzetközi jogokra is lehet alárendelkezett. Bármilyen ezen Általános Szerződési Feltételekkel kapcsolatos jogi eljárás kizárólag az Egyesült Államok bíróságai előtt kezdeményezett, és Ön beleegyezik ezeknek a bíróságoknak személyes illetékességébe. ',
    block24:
      'Felek kapcsolat. Noam és Ön független vállalkozók, és egyik fél sem jogosult a másik félre képviselni, kötelezni vagy kötelezettségeket vállalni a másik fél számára a másik fél előzetes írásbeli hozzájárulása nélkül.',
    block25:
      '(b) Márkahasználat. A Noam vagy bármely leányvállalatának nevét, logójait vagy védjegyeit nem használhatja előzetes írásos engedélyünkkel nélkül.',
    block26:
      'Ha ezeknek az előírásoknak bármely rendelkezése érvénytelennek, jogellenesnek vagy végrehajthatóvá nem tehetőnek kerül meghatározásra, a fennmaradó rendelkezések teljes érvényben és hatályban maradnak.',
    block3:
      'Ha 18 év alatti vagy, az Szolgáltatás használatához szüleidtől vagy jogi képviselőidtől engedélyt kell szerezned. Ha más személy vagy szervezet nevében használod az Szolgáltatást, jogosultságot kell rendelkezned az ezen feltételek nevében való elfogadásához. Fiók regisztrálásához pontos és teljes információkat kell szolgáltatnod. Nem adhatod ki hozzáférési hitelesítőjeidet vagy fiókodat a szervezetedön kívüli senkinek, és felelős vagy az összes, hitelesítőjeid használatával végrehajtott tevékenységért.',
    block4:
      '(a) Szolgáltatás használata. A szolgáltatás elérésére ezeken a feltételeken alapul, és nemexkluzív jogosultságot biztosítunk Önnek a szolgáltatás használatához. A szolgáltatás használata során Önnek meg kell szegnie ezeket a feltételeket és az összes alkalmazható jogszabályt. Mi és a kapcsolt vállalataink birtokoljuk az összes jogot, címet és érdeket a szolgáltatásben.',
    block5:
      '(b) Visszajelzés. Üdvözöljük a visszajelzéseket, megjegyzéseket, ötleteket, javaslatokat és fejlesztési javaslatokat. Ha bármilyen ilyen tartalmat biztosítasz, mi szabadon felhasználhatjuk azt bármilyen korlátozás nélkül és anélkül, hogy Önnek kártérítést fizetnénk.',
    block6:
      '(c) Korlátozások. Nem teheted meg a következőket: (1) A Szolgáltatás használata olyan módon, amely megsért, elszív vagy sérti mások jogait; (2) A Szolgáltatás modelleinek, algoritmusainak és rendszereinek forráskódját vagy alapvető komponenseit megpróbálni visszafejteni, decompilálni, szétszedni, lefordítani vagy egyéb módon felfedezni (kivéve, ha az alkalmazandó jogszabályoktilosítják ilyen korlátozásokat); (3) A Szolgáltatás kimenetét felhasználni a Noam-ot versenyező modellek fejlesztésére; (4) Adatok vagy kimenetek kinyerése a Szolgáltatásból bármilyen automatizált vagy programozási módszerrel, kivéve az API-on keresztül engedélyezett eseteket, beleértve a scrapinget, a webgyűjtést vagy a webdata-kinyerést; (5) A Szolgáltatás kimenetének nem mesterségesen generáltként való ábrázolása, vagy egyéb módon a használati szabályzatainkat sértése; (6) API-kulcsok vásárlása, eladása vagy átadása előzetes engedélyünket nélkül; vagy (7) Bármilyen 13 év alatti gyermek vagy a megfelelő digitális hozzájárulási korú személy személyes adatait megadni nekünk. Betartani kell az összes sebességkorlátot és egyéb követelményt a dokumentációban.',
    block7:
      '(d) Harmadik felek szolgáltatások. Bármilyen harmadik felek szoftver, szolgáltatás vagy egyéb termék, amely a Szolgáltatással kapcsolatos, az saját feltételei szerint szabályozza, és nem vállalunk felelősséget harmadik felek termékeinek tekintetében.',
    block8:
      '(a) A tartalmakod. Bármilyen bemenetet ("Bemenet") szolgáltathat a Szolgáltatásnak, és kaphatsz kimenetet ("Kimenetet"), amelyet a Bemenet alapján generálnak és küldenek vissza (együttes nevén "Tartalom"). A felek között, és az alkalmazható jog megengedett mértékben, Ön Ön tulajdonosa az összes Bemenetnek. A Noam a Tartalmat felhasználhatja a Szolgáltatás biztosításához és fenntartásához, az alkalmazható jogszabályoknak való megfeleléshez, valamint szabályzataink érvényesítéséhez. Ön felelős a Tartalomért, beleértve annak biztosítását, hogy ne sérüljön meg az alkalmazható jogszabályok vagy ezeket a feltételeket.',
    block9:
      '(b) Pontosság. Az mesterséges intelligencia és a gépi tanulás gyorsan fejlődő kutatási területek. Folyamatosan törekszünk szolgáltatásunk fejlesztésére, hogy pontosabb, megbízhatóbb, biztonságosabb és hasznosabb legyen. A gépi tanulás valószínűségi jellegéből adódóan szolgáltatásunk használata bizonyos esetekben helytelen eredményeket eredményezhet, amelyek nem tükrözhetik pontosan az igazi személyeket, helyeket vagy tényeket. Az Ön használati esetében megfelelően értékelnie kell bármely kimenet pontosságát, beleértve az eredmények manuális áttekintését is.',
    subTitle1: 'Regisztráció és hozzáférés',
    subTitle10: 'Tagadhatóság',
    subTitle2: 'Használati Követelmények',
    subTitle3: 'Tartalom',
    subTitle4: 'Díjak és Fizetés',
    subTitle5: 'Titkosítás, Biztonság és Adatvédelmi',
    subTitle6: 'Időtartam és lemondás',
    subTitle7: 'Felelősségvállalás; Kivételek; Felelősségkorlátozás',
    subTitle8: 'Tartalomirányító jog és székhely',
    subTitle9: 'Általános Szerződési Feltételek',
    title: 'Szolgáltatási feltételek',
    updateTime: 'Frissítve: 2024. március 15.',
  },
  trialModal: {
    btn: 'Kezdje most (csak 0,99 USD)',
    chat: 'ChatPDF',
    desc1: 'Az próbaidőszak után éves díjat fogsz fizetni 180 USD értékben',
    desc2: 'Bármikor lemondható',
    focus: 'Fókuszálás',
    hover: 'Görgő fordítás',
    image: 'Kép fordítás',
    installBtn: 'Telepítse most, hogy megkapja ajándékát',
    memo: 'Kedvencek kezelése',
    pdf: 'PDF párhuzamos fordítás',
    realtime: 'Gyors fordítás',
    select: 'Szóválasztási fordítás',
    title: 'Üdvözlő ajándék',
    trialText: '7 napos próba',
    video: 'Videofordítás',
    videoSummary: 'Videó összefoglalás',
    web: 'Párhuzamos fordítás',
    webSummary: 'Web összefoglaló',
  },
  upgradeModal: {
    btn: 'Frissítés most',
    chat: { free: 'Elérted a ChatPDF korlátját', pro: 'Elérte a ChatPDF havi korlátját' },
    contactStr:
      'Kérjük, várja meg a következő alaphelyzetbe állítást, vagy lépjen kapcsolatba velünk a contact@noam.tools címen.',
    limitAlertStr: 'Elérted az ingyenes terv korlátját. Frissíts a folytatáshoz.',
    more: 'Tervek megtekintése',
    pageLimit: { free: 'Elérted a PDF oldalszám korlátját' },
    title: 'Emlékeztető',
    upgradeAlertStr: 'Elérted az ingyenes csomag korlátját. Frissíts, hogy folytathasd.',
    upload: {
      free: 'Elérted a PDF fordítási korlátod',
      pro: 'Elérte a havianyi PDF fordítási korlátját',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Csatlakozz most',
      label: 'Új Felhasználói Juttatások:',
      remain: 'Csak 30 maradt',
      text: 'Csak 100 hely áll rendelkezésre! Szerezd meg most a tiédet!',
    },
  },
  aiPdfTranslator: {
    title: 'Ingyenes AI PDF Fordító: PDF fordítás összehasonlítással bármilyen nyelven',
    desc: 'PDF-fájlokat könnyen fordíthat bármilyen nyelvre AI segítségével. Összehasonlíthatja az eredeti és a fordított szöveget oldalon-olaszt, gyorsan és ingyenesen.',
    keywords:
      'GPT-4、AI Asszisztens、Fordítás、Összefoglalás、Fókusz、ChatPDF、Jegyzet、hatékonyság',
    sourceToTarget: {
      title: 'Ingyenes PDF fordítási eszköz: fordítsa ingyen {{source}}-t {{target}}-ra',
      desc: 'PDF-fájljaidat ingyenesen fordítsa bármilyen forrásnyelvből a kívánt nyelvre. Gyors, pontos és biztonságos PDF-fordítás fejlett AI támogatásával.',
    },
    headerIntroduce: {
      title: 'Noam: Több, mint csak online fordítás',
      introduce1: {
        title: 'Noam · PDF Olvasó',
        desc: '✨Oldal a oldalhoz fordítás + AI kérdések és válaszok. Gyorsan és pontosan fordítsa le a PDF-eket a célnyelvére. Szabadon tegyen fel kérdéseket a tartalommal kapcsolatban, hogy mélyebben megértse PDF-fájljait.',
      },
      introduce2: {
        title: 'Noam · Oldaloldal Translation Bővítmény',
        desc: '👏Oldja meg az összes weboldal-fordítási igényét:',
        detail1: { title: 'Weboldal fordítása:', desc: 'Oldalsó kétnyelvű nézet' },
        detail2: { title: 'Szófordítás:', desc: 'Egynappal gyors fordítás' },
        detail3: { title: 'Gyors fordítás:', desc: 'Szókat vagy mondatokat azonnal lefordítson.' },
        detail4: { title: 'Képfordítás:', desc: 'Cserélje ki a képeket lefordítottakra.' },
        detail5: { title: 'Videofordítás:', desc: 'Kétnyelvű feliratok jobb nézőélményért.' },
        footer: 'Tapasztalja meg több AI-vezérelt olvasási funkciót okosabb fordításért!',
      },
    },
    subtitle: 'PDF Online Fordítás Ingyenes',
    introduce: {
      module1: {
        detail1: {
          title: 'Valós idejű oldalt-olyan PDF fordítás',
          desc1:
            'Az eredeti és lefordított tartalmat azonnal szinkronizált, oldalsó elrendezésben jelenítse meg',
          desc2: 'Egyszerűen hasonlítsa össze a két verziót szinkronizált görgetéssel',
          desc3: 'Kövesse az azonos formázást egy konzisztens olvasási élmény érdekében',
        },
        detail2: {
          title: 'Pontos Tartalom-illesztés és Ellenőrzés',
          desc1: 'A forrás- és fordított szöveg tökéletes egyeztetése könnyű ellenőrzés céljából',
          desc2: 'Minden tartalomrészlet pontos egyezik meg mindkét verzióban',
          desc3:
            'Gyorsan azonosítsa és oldja meg a fordítási eltéréseket megbízható eredmények érdekében',
        },
      },
      module2: {
        detail1: {
          title: 'Több fejlett AI-modell pontos fordításra',
          desc1: 'Válasszon vezető AI modellek közül a fordítási követelményeinek megfelelően',
          desc2: 'Optimális eredmények biztosítása különféle dokumentumtípusok és iparágak számára',
          desc3:
            'A rugalmas modellopciók személyre szabott megoldásokat kínálnak minden forgatókönyvhöz',
        },
        detail2: {
          title: 'Haladó AI fordítás minden tartalomtípushoz',
          desc1:
            'Erős AI modellünk garantálja a magas pontosságot és a természetes nyelv megértését',
          desc2: 'Könnyen kezeli a technikai, akadémiai és kreatív dokumentumokat',
          desc3: 'Megbízható eredményeket biztosít az összes fordítási igényedre',
          desc4:
            'Intelligens alkalmazkodás különböző tartalomtípusokra optimális teljesítmény érdekében',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligens Dokumentuminterakció',
          desc1:
            'Egyszerűen beszélgessen PDF-jével és prezentációs fájljaival fejlett AI segítségével',
          desc2: 'Kérdezdezheted azonnal a dokumentum tartalmáról, és pontos válaszokat kaphatsz',
          desc3: 'Gyorsan generáljon tömör összefoglalókat hosszú dokumentumokhoz',
        },
        detail2: {
          title: 'Mély tartalomelemzés és zökkenőmentes integráció',
          desc1: 'Kulcsinformációk kinyerése és komplex adatok elemzése AI-alapú megértéssel',
          desc2: 'Beszerezze meg a technikai, akadémiai vagy kreatív anyagok betekintését',
          desc3:
            'Zökkenőmentesen integrálható PDF-átalakítóval egy teljes dokumentumkezelési megoldáshoz',
        },
      },
      module4: {
        detail1: {
          title: 'A PDF fordítás mellett: Egyértelmű weboldal-fordítási megoldás',
          desc: 'Fedezze fel az erős oldalon-együtt fordítási bővítményünket, amelyet minden online olvasási forgatókönyvhöz terveztek.',
          desc1: 'Weboldal fordítás: élvezze a kétnyelvű tartalmat szinkronizált oldalsó nézetben',
          desc2: 'Szófordítás: Kiemelt szavakat egyetlen kattintással azonnal lefordítja',
          desc3:
            'Gyorsfordítás: Fordítson le bármilyen szöveget vagy mondatot azonnal gyors megértés érdekében',
          desc4: 'Képfordítás: Az eredeti képek automatikus cseréje fordított változatokkal',
          desc5:
            'Videofordítás: Nézzen meg videókat kétnyelvű feliratokkal a jobb élmény érdekében',
        },
      },
    },
    question: {
      title: 'Gyakran Ismételt Kérdések',
      answer1: {
        title: 'A Noam PDF Translator ingyenesen használható PDF fordításra?',
        content:
          'Igen, ingyenesen lefordíthat PDFs-t a Sider PDF Translatorral! 5000 token ingyenes kvótát kínálunk, ami elegendő a piacon általában előforduló legtöbb PDF-dokumentum fordításához. Ha nagyobb fájlokat kell lefordítani, vagy speciális funkciókat igényel, választhatja a prémium csomagjainkra történő frissítést még több lehetőségért.',
      },
      answer2: {
        title: 'Mennyire pontos a Noam PDF Translator?',
        content:
          'A Noam PDF Fordító kifejezetten pontos fordításokat biztosít fejlett AI-technológiának alkalmazásával és a dokumentumok kontextusának mélyreható megértésével. Bár egyetlen automatikus fordítás sem tökéletes, oldalt oldalon megjelenített megjelenítésünk lehetővé teszi, hogy könnyen áttekinthesse és finomítsa minden fordítást, így biztosítva, hogy az eredmény megfeleljen minőségi elvárásainak. Tapasztalja meg a megbízható és pontos PDF-fordítást a Noam-mal.',
      },
      answer3: {
        title: 'Lehet-e lefordítani a szkennelt PDF-eket?',
        content:
          'Igen, a szkennelt PDF-eket a beépített OCR (Optikai Karakterfelismerés) technológiánkkal fordíthatja le. Rendszerünk automatikusan kinyeri a szöveget a szkennelt dokumentumokból és képalapú PDF-ekből, majd lefordítja a tartalmat Önnek. Ez biztosítja, hogy még a nem szerkeszthető vagy csak képből álló PDF-ek is pontosan legyenek lefordítva.',
      },
      answer4: {
        title: 'Mennyi időt vesz igénybe a fordítás?',
        content:
          'A fordítás gyors és hatékony – a legtöbb dokumentum másodpercekből néhány percig kerül feldolgozásra, attól függően, hogy milyen hosszú és komplex. Például egy standard 10 oldalas PDF fordítása általában kevesebb mint 2 percet vesz igénybe. élvezze a gyors leadási idejét minden dokumentumfordítási igénye esetén!',
      },
      answer5: {
        title: 'Tarthatnom a mellékes nézetet az olvasáshoz?',
        content:
          'Igen, mindig并列olvashatja dokumentumait. Ez a elrendezés lehetővé teszi, hogy könnyen összehasonlítsa az eredeti és a lefordított tartalmat, biztosítva egy zökkenőmentes és hatékony olvasási élményt.',
      },
    },
    freeTrial: 'Ingyenes próba',
    toLanguage: { title: 'PDF AI Fordítási Párok', item: '{{target}}' },
  },
  aiPdfTranslate: {
    header: {
      faq: 'GYIK',
      blog: 'Blog',
      features: 'Jellemzők',
      pricing: 'Árazás',
      button: 'Fordítson most',
    },
    hero: {
      upload: {
        title: 'Töltsd fel a PDF fájlod',
        highlight: 'Kattintson a böngészésre',
        max: 'Max',
        desc: 'vagy húzzon és dobjon',
      },
      to: 'a',
      title: 'Ingyenes PDF Fordító',
      pill: 'AI-vezérelt PDF-fordító',
      model: 'GPT-4 és Claude',
      support: 'OCR Támogatás',
      desc: 'Gyors, pontos fordítások, amelyek megőrzik az eredeti elrendezést. A Noam AI támogatja az OCR-t és az oldalon-együtt nézeteket.',
      free: 'Ingyenes próba',
      translated: 'Fordította: Noam',
      complete: 'Fordítás kész',
    },
    ticker: {
      ocr: 'OCR technológia',
      pdf: 'PDF Fordítás',
      multi: 'Többnyelvű',
      format: 'Formátum megőrzése',
      side: 'Oldal a oldal mellett',
      web: 'Webfordítás',
      secure: 'Biztonságos és Privát',
      chat: 'Beszélgetés PDF-fájlokkal',
    },
    comparison: {
      bad: {
        title: 'Standard fordítás',
        head: 'Elveszett formázás és kontextus',
        text1: 'Hiba: A elrendezés sérült. A képek helytelenül helyezkednek el.',
        text2:
          'A szövegek átfedik egymást, és a betűtípusok nem egyértelműek. Nehéz olvasni és nem szakmai...',
      },
      dump: { title: 'Egyszerű szöveges kibocsátás' },
      good: {
        title: 'Noam AI Fordítás',
        tag: 'Tökéletes Eredmény',
        sub: ' tökéletes formázás, kontextusérzékenység',
      },
      title: 'Miért válassza a Noam AI-t?',
      desc: 'Ne harcoljon tovább a másolás-illesztés fordításokkal. Érezze meg a különbséget a szabványeszközök és az AI-alapú kontextusérzékeny fordításunk között.',
    },
    showcase: {
      title1: 'Bármilyen dokumentum',
      kicker: 'TÁMogatott dokumentumok',
      title2: 'Bármilyen nyelv',
      carousel3: 'Akadémiai folyóirat',
      carousel4: 'Gyógyszerészet',
      carousel2: 'Építészet',
      note: 'Könnyen kezelheti a technikai, akadémiai és kreatív dokumentumokat.',
      carousel1: 'Művészet',
      carousel7: 'Szerződés',
      carousel8: 'Szabályzat',
      carousel5: 'Pénzügy',
      carousel6: 'Jog',
    },
    features: {
      big: {
        title: 'Fejlett AI-modellek (GPT-4, Claude)',
        desc: 'Válasszon vezető AI modellek közül a fordítási követelményeinek megfelelően. Gondoskodjon optimális eredményekről különféle dokumentumtípusok esetén.',
      },
      grid1: {
        title: 'OCR Támogatás',
        desc: 'Szöveget azonnal nyerhet ki és lefordíthat szkennelt PDF-ekből és képekből.',
      },
      grid2: {
        title: 'Magasfelbontású exportálás',
        desc: 'Töltse le lefordított dokumentumait PDF formátumban az eredeti elrendezéssel.',
      },
      grid3: {
        desc: 'Szinkronizált görgetés az eredeti és fordított szöveg összehasonlításához.',
        title: 'Oldal-az-öldali összehasonlítás',
      },
      title1: 'Nem Csak Fordítás',
      title2: 'Ez egy forradalom',
      line1: 'Technikai Cikk.pdf',
      line2: 'Nyelvfelismerés: angol...',
      line4: 'Fordítás kész (99% pontosság)',
      line3: 'Modell: GPT-4o (Magas Pontosság)',
    },
    testimonials: {
      review1: {
        role: 'Kutató',
        content:
          'A Noam AI több órát spóroltam az akadémiai cikkek fordításán. A oldalsó nézet hihetetlenül hasznos a technikai szavak ellenőrzésére.',
      },
      review2: {
        role: 'Globális Marketinges',
        content:
          'A legjobb PDF fordító, amivel jártam. Tökéletesen megőrzi az eredeti formázást, ami kulcsfontosságú marketing prezentációinkhoz.',
      },
      review3: {
        role: 'Jogi Tanácsadó',
        content:
          'Pontos és gyors. Szerződéstöbbítésekre használom, és az OCR funkció a szkenneltek dokumentumokon tökéletesen működik.',
      },
      kicker: 'Felhasználók által szeretett',
      title: 'Felhasználóink mondtak',
    },
    cta: {
      title: 'Készen állsz a nyelvi akadályok lebontására?',
      hint: 'Fordítsd le a következő tartalmat helyesen magyarra:',
      desc: 'Csatlakozz a 10 000-nél több felhasználóhoz, és kezdje meg ma a dokumentumai fordítását a Noam AI segítségével.',
      button: 'Kezdje el ingyen fordítani',
    },
    languagePairs: {
      title: 'Angol PDF AI Fordítási Párok',
      desc: 'A Noam AI által támogatott népszerű fordítási irányok',
    },
    footer: {
      privacy: 'Adatvédelmi Nyilatkozat',
      contact: 'Kapcsolat a támogatással',
      about: 'Rólunk',
    },
  },
}

export default TRANSLATION
